<script>
export default {
  computed: {
    breadcrumb: function () {
      let pathList = this.$route.fullPath.split("/").slice(0);
      let breadcrumb = [];
      pathList.forEach(function (segment, index) {
        if (segment) {
          breadcrumb.push({
            name: segment,
            link: pathList.slice(0, index + 1).join("/")
          });
        }
      });
      return breadcrumb;
    }
  }
};
</script>
<template>
  <nav>
    <div class="nav-wrapper light-blue darken-3">
      <div class="col s12" style="padding-left: .5rem">
        <router-link v-for="crumb in breadcrumb" class="breadcrumb" v-bind:to="crumb.link" v-bind:key="crumb.link">
          {{ crumb.name }}
        </router-link>
      </div>
    </div>
  </nav>
</template>
